export class MockLocation {
  forward = jasmine.createSpy('forward');
  back = jasmine.createSpy('back');
  path = jasmine.createSpy('path');
}
